import React from "react";
import PropTypes from "prop-types";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import styles from "./SVGViewer.module.css";

const SVGViewer = ({ svgGraph, documentRef, enableZoom = true }) => {
    if (!svgGraph) {
        return <div className={styles.viewer}><div className={styles.empty}>ECG waveform is unavailable.</div></div>;
    }

    return (
        <div ref={documentRef} className={styles.viewer}>
            <TransformWrapper
                initialScale={1}
                smooth={true}
                wheel={
                    enableZoom ?
                        { step: 0.8, animationType: "easeOut" } : {
                            disabled: true, 
                        }}
                pinch={
                    enableZoom ?
                        { step: 0.8, animationType: "easeOut" } : {
                            disabled: true, 
                        }}
                doubleClick={{
                    step: enableZoom ? 0.8 : 0,
                    animationType: "easeOut",
                }}
            >
                {({ zoomIn, zoomOut, resetTransform }) => (
                    <>
                        <div className={styles.toolbar}>
                            <span className={styles.title}>ECG waveform</span>
                            {enableZoom && (
                                <div className={styles.actions}>
                                    <button className={styles.action} type="button" onClick={() => zoomOut()} aria-label="Zoom out">−</button>
                                    <button className={styles.action} type="button" onClick={() => resetTransform()} aria-label="Reset ECG zoom">Reset</button>
                                    <button className={styles.action} type="button" onClick={() => zoomIn()} aria-label="Zoom in">+</button>
                                </div>
                            )}
                        </div>
                        <div className={styles.canvas}>
                            <TransformComponent wrapperStyle={{ width: "100%", height: "100%" }} contentStyle={{ width: "100%" }}>
                                <div className={styles.svgContent} dangerouslySetInnerHTML={{ __html: svgGraph }} />
                            </TransformComponent>
                        </div>
                    </>
                )}
            </TransformWrapper>
        </div>
    )
}
export default SVGViewer

SVGViewer.propTypes = {
    svgGraph: PropTypes.string,
    documentRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    enableZoom: PropTypes.bool,
};
